import React, { useState, useEffect } from 'react';
import { Container, Typography, Box } from '@mui/material';
import PaymentList from './components/PaymentList';
import PaymentSummary from './components/PaymentSummary';
import { Payment } from '../../models/Payment';
import { getAllPayments } from '../../services/paymentService';

const Payments: React.FC = () => {
    const [payments, setPayments] = useState<Payment[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        fetchPayments();
    }, []);

    const fetchPayments = async () => {
        try {
            setLoading(true);
            const fetchedPayments = await getAllPayments();
            setPayments(fetchedPayments);
            setError(null);
        } catch (err) {
            setError('Failed to fetch payments');
            console.error('Error fetching payments:', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            <Typography variant="h4" component="h1" gutterBottom>
                Payments
            </Typography>
            <PaymentSummary payments={payments} />
            <PaymentList payments={payments} loading={loading} error={error} onRefresh={fetchPayments} />
        </Container>
    );
};

export default Payments; 